<template>
  <el-card
    id="leaderTasksCard"
    v-loading="loading"
    class="clear-card leaderTasks"
    :class="{
      detailsView: isDetailsView,
      listView: !isDetailsView,
      mobileMode: ['mobile', 'tablet'].includes($mq),
      deskMode: ['desktop', 'laptop'].includes($mq),
    }"
    shadow="hover"
    :body-style="{
      padding: '0',
      height: 'calc(100% - 55px)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    }"
  >
    <div
      slot="header"
      class="header defaultCursor"
    >
      <span>{{ title }}</span>
    </div>
    <template>
      <div
        v-if="filteredTaskList && filteredTaskList.length > 0"
        class="content"
      >
        <div
          v-for="(task, tKey) in filteredTaskList"
          :key="tKey"
          class="task"
          @click="clickTask(task)"
        >
          <div
            class="status"
            :class="{completed: task.status === 'completed'}"
          ></div>
          <div class="name">
            {{ $t(`processTasks.${task.description}`) }}
          </div>
        </div>
      </div>

      <div
        v-else
        class="noData"
      >
        {{ $t('coach.leader.sessionDetail.noData') }}
      </div>
    </template>
  </el-card>
</template>

<script>
import { mapState } from 'vuex';
import api from '@/api';
import TaskFilterBoth from './TaskFilterBoth';

export default {
  props: {
    leader: {
      type: Object,
      default() {
        return {
          tasks: [],
        };
      },
    },

    meetings: {
      type: Object,
      default: null,
    },

    tasks: {
      type: Array,
      default() {
        return [];
      },
    },

    session: {
      type: Number,
      default: null,
    },

    filtered: {
      type: Boolean,
      default: false,
    },

    title: {
      type: String,
      default: 'My Tasks',
    },

    isDetailsView: {
      type: Boolean,
      default: false,
    },

    taskFrom: {
      type: String,
      default: 'coach',
    },
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),

    sessionOneStatus() {
      let status = 'none';
      if (this.session === 1 && this.meetings && this.meetings.meeting_status) {
        const sessionOne = this.meetings.meeting_status.find((el) => el.session_id === 'session_1');
        status = sessionOne.status;
      }
      return status;
    },

    tasksLocal: {
      cache: false,
      get() {
        // return this.tasks.filter((el) => {
        //   if (el.coach_task_id === 'review_agenda') {
        //     return false;
        //   }
        //   return true;
        // });
        return this.tasks;
      },
      set(newValue) {
        this.$emit('update:tasks', newValue);
      },
    },

    filteredTaskList() {
      let list = [];

      if (this.tasksLocal && this.sessionOneStatus) {
        if (this.taskFrom === 'leader') {
          const basic = this.tasksLocal
            .filter((task) => task.description.startsWith('scheduleSession'));

          const filtered = this.tasksLocal
            .filter((task) => TaskFilterBoth.sessions.leader[`session_${this.session}`]
              .includes(task.description));

          list = [...basic, ...filtered];
        } else if (this.taskFrom === 'coach') {
          if (this.isDetailsView && this.session === 1) {
            if (this.sessionOneStatus === 'none') {
              list = [...this.tasksLocal];
            } else if (this.sessionOneStatus === 'completed') {
              const filtered = this.tasksLocal
                .filter((task) => TaskFilterBoth.sessions.coach.after_1
                  .includes(task.description));
              list = [...filtered];
            } else {
              const filtered = this.tasksLocal
                .filter((task) => TaskFilterBoth.sessions.coach.session_1
                  .includes(task.description));
              list = [...filtered];
            }
          } else {
            list = [...this.tasksLocal];
          }
        }
      }

      return list;
    },
  },

  methods: {
    async clickTask(task) {
      if (this.isDetailsView) {
        try {
          this.loading = true;
          const response = await api.saveCoachTask(this.leader.uuid, {
            coach_task_id: task.coach_task_id,
            status: task.status === 'completed' ? 'ongoing' : 'completed',
          });

          const index = this.tasksLocal.findIndex(
            (el) => el.coach_task_id === task.coach_task_id,
          );
          this.$set(this.tasksLocal[index], 'status', response.data.status);

          this.$emit('update:tasks', this.tasksLocal);
          this.loading = false;
        } catch (err) {
          console.log(err);
          if (err.msg) {
            this.$message.error(err.msg);
          }
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  #leaderTasksCard {
    .header {
      font-weight: bold;
      text-align: center;
    }

    .task {
      display: flex;
      padding: 15px 20px;
      align-items: center;

      .status {
        min-width: 12px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        margin-right: 10px;
        background: #c4c4c4;

        &.completed {
          background: #66d73f;
        }
      }

      &.disabled {
        color: #ffffff6b;

        &:hover {
          cursor: not-allowed;
        }
      }
    }

    &.detailsView {
      .task:not(.disabled):hover {
        background-color: rgba(255, 255, 255, 0.2);
        cursor: pointer;
      }
    }

    .noData {
      color: #c4c4c4;
      text-align: center;
      padding: 5px 0;
      height: 100%;
      min-height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>

<style lang="scss">
  #leaderTasksCard {
    &.mobileMode {
      .el-card__header {
        border-bottom: none !important;
      }
    }
  }
</style>
